import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { themeColor } from '../../Theming';

const Container = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  margin-top: 35px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 700px;
  box-sizing: border-box;
  flex-direction: column;
  margin: 0 auto;
  padding: 10px clamp(20px, 5vw, 48px) max(16px, env(safe-area-inset-bottom));

  @media (max-width: 390px) {
    padding: 8px 20px max(8px, env(safe-area-inset-bottom));
  }

  & > button {
    background-color: ${themeColor('successGreen')};
    height: 56px;
    margin-top: 0px;
    border-radius: 5px;
    color: ${themeColor('white')};
    font-size: 20px;
    font-weight: 700;
    font-family: Fira Sans;
    border: none;

    @media (max-width: 390px) {
      height: 48px;
      font-size: 17px;
    }

    &:last-child {
      background-color: ${themeColor('white')};
      color: #646464;
      border: 1px solid #646464;
      margin-top: 20px;
      height: 44px;
      font-size: 18px;
      font-weight: 700;
      font-family: Fira Sans;

      @media (max-width: 390px) {
        height: 38px;
        margin-top: 10px;
        font-size: 16px;
      }
    }
  }
`;

interface ActivateNowProps {
  navigateToSettings?: () => void;
  close?: () => void;
}

const ActivateNow: React.FC<ActivateNowProps> = ({
  navigateToSettings,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ButtonsContainer>
        <button
          id="android-accessiblity-button-agree"
          onClick={navigateToSettings}
          aria-label="Agree to Accessibility permissions"
        >
          {t('KindredPluginActivation.androidAccessibility.agree')}
        </button>
        <button
          onClick={close}
          id="android-accessiblity-button-disagree"
          aria-label="Disagree to Accessibility permissions"
        >
          {t('KindredPluginActivation.androidAccessibility.disagree')}
        </button>
      </ButtonsContainer>
    </Container>
  );
};

export default ActivateNow;
